import React, { useEffect, useState } from "react";
import { WhatsappLogo } from "@phosphor-icons/react";
import { COMPANY } from "../lib/constants";
import { useLang } from "../lib/i18n";
import { getChosenPlan } from "../lib/plan";

export const WhatsAppFloat = () => {
  const { lang } = useLang();
  const [plan, setPlan] = useState(() => getChosenPlan());

  useEffect(() => {
    const onChange = () => setPlan(getChosenPlan());
    window.addEventListener("px-plan-change", onChange);
    window.addEventListener("storage", onChange);
    return () => {
      window.removeEventListener("px-plan-change", onChange);
      window.removeEventListener("storage", onChange);
    };
  }, []);

  const msg = plan
    ? lang === "hi"
      ? `नमस्ते! मुझे Atikxzio HMS का फ्री डेमो बुक करना है। मेरी रुचि ${plan.name} प्लान (${plan.price}/माह) में है।`
      : `Hi! I'd like to book a free demo of Atikxzio HMS. I'm interested in the ${plan.name} plan (${plan.price}/month).`
    : lang === "hi"
      ? "नमस्ते! मुझे Atikxzio HMS का फ्री डेमो बुक करना है।"
      : "Hi! I'd like to book a free demo of Atikxzio HMS.";

  return (
    <a
      href={`https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(msg)}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="group fixed bottom-24 right-5 z-[60] flex items-center gap-0 rounded-full bg-[#25D366] shadow-[0_8px_32px_rgba(37,211,102,0.5)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(37,211,102,0.6)] lg:bottom-6 lg:right-6"
      data-testid="whatsapp-float"
    >
      <span aria-hidden className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366]/40" style={{ animationDuration: "2.5s" }} />
      <span className="flex h-14 w-14 items-center justify-center">
        <WhatsappLogo size={30} weight="fill" className="text-white" />
      </span>
      <span className="max-w-0 overflow-hidden whitespace-nowrap text-sm font-bold text-white transition-all duration-300 group-hover:max-w-[160px] group-hover:pr-5">
        {lang === "hi" ? "WhatsApp पर बात करें" : "Chat with us"}
      </span>
    </a>
  );
};
